import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function Migrations(props) {
  const green = getColorValue('illustrationGreen');
  const purple = getColorValue('illustrationPurple');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <g fill={green}>
        <path d="m245.02 82.6504-202.3198 64.5996 72.2098 35.57z" />
        <path d="m240.85 85.0303-146.6298 95.1697 65.9598 38.76z" />
        <path d="m240.86 85.0303-.5 1.2-125.45 96.5897-14.06-6.92z" />
      </g>
      <path
        d="m240.86 85.0303-.5 1.2-125.45 96.5897-14.06-6.92z"
        fill={getColorValue('tealDark')}
      />
      <path d="m113.11 55.5-83.11 17.5 27.29 17.08z" fill={purple} />
      <path d="m111.36 56.2803-62.1901 31.92 20.66 23.4297z" fill={purple} />
      <path d="m111.36 56.2803-.25.46-53.82 33.34-5.31-3.32z" fill={purple} />
      <path
        d="m111.36 56.2803-.25.46-53.82 33.34-5.31-3.32z"
        fill={illustrationColors.staticRed}
      />
    </svg>
  );
}

export default Migrations;
